/**
 * Per-gallery-instance lightbox open/index state.
 * Scroll lock is handled inside LightboxComponent.
 */
export class GalleryLightboxState {
  isOpen = false;
  index = 0;

  openAt(index: number): void {
    this.index = index;
    this.isOpen = true;
  }

  open(): void {
    this.isOpen = true;
  }

  close(): void {
    this.isOpen = false;
  }

  setIndex(index: number): void {
    this.index = index;
  }
}
